import { render, staticRenderFns } from "./PotentialResourcesOther.vue?vue&type=template&id=4b902e11&scoped=true&"
import script from "./PotentialResourcesOther.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesOther.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesOther.vue?vue&type=style&index=0&id=4b902e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b902e11",
  null
  
)

export default component.exports